<div @animation *ngIf="isOpen" (@animation.done)="onAnimationEvent($event)" attr.data-cy="lendio-alert-{{level}}">
  <mat-card [ngClass]="[
    'lendio-alert',
    'lendio-alert--' + level
  ]"
  >
    <i class="lendio-alert__icon fa fa-lg fa-{{ icons[level] }}"></i>
    <ng-content></ng-content>
    <div class="lendio-alert__message mat-body-2" data-cy="lendio-alert-message">{{ message }}</div>
    <div class="lendio-alert__dismiss" *ngIf="dismissible">
      <button mat-icon-button (click)="dismiss()">
        <i class="fa fa-lg fa-times"></i>
      </button>
    </div>
  </mat-card>
</div>
